export default __webpack_public_path__ + "static/media/BG-Green-0003.4529f594.png";